import React, { useContext } from 'react';
import { AppContext } from '../AppContext';

const RevertImpersonationBanner = () => {

    const { revertToOriginalUser } = useContext(AppContext);
    const currentUser = useContext(AppContext).currentUser;

    return (
        <div style={{ position: 'fixed', bottom: 0, width: '100%', backgroundColor: '#B8309E', padding: '10px', textAlign: 'center', zIndex: 1000, display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ alignSelf: 'center', fontWeight: 'bold', paddingLeft: '2rem', color: '#FFF' }}>{"Actualmente está actuando en nombre de " + currentUser.apellidos + " " + currentUser.nombres}</span>
            <button onClick={revertToOriginalUser} style={{ marginLeft: '10px' }} className="btn btn-light">
                Dejar de actuar en nombre del usuario
            </button>
        </div>
    );
};

export default RevertImpersonationBanner;
